<template>
  <v-container>
    <h2>Update admin</h2>
    <v-row>
      <v-col lg="10" md="12" sm="12">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.password"
              type="password"
              label="Password"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="updateUserPassword"
          >
            Update
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'user-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "UserEditPassword",
  components: { },
  data: () => ({
    user: {
      id: null,
      password: null
    }
  }),
  mounted () {
    this.user.id = this.$route.params.id
  },
  methods: {
    async updateUserPassword () {
      try {
        if (this.requireField()) {
          await this.$http.put(`/back-office/admins/${this.user.id}/password`, this.user, authHeader())
          this.$router.push({ name: 'user-list'})
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      if (!this.user.password) {
        alert('Please fill in password')
        return false;
      }
      return true
    }
  },
};
</script>
